import React, { useContext, useEffect } from 'react';
import { Route, RouteProps } from 'react-router-dom';

import { AppContext } from './App';

function RouteApplier({ children, title }: React.PropsWithChildren<{ title: string }>) {
  const { setPageTitle } = useContext(AppContext);

  useEffect(() => setPageTitle(title), [title, setPageTitle]);

  return <>{children}</>;
}

export function AppRoute({
  children,
  title,
  ...routeProps
}: React.PropsWithChildren<{ title: string } & RouteProps>) {
  return (
    <Route {...routeProps}>
      <RouteApplier title={title}>{children}</RouteApplier>
    </Route>
  );
}
